import { useEffect } from 'react'
import { flixApiEvents, useFlixApiContext } from '@mwxltd/flix-api-client'
import cookieStore from '@flix/common/services/store/cookieStore'

const leadTrackedStore = cookieStore('flix_reg_lead_tracked')

export const useTrackRegistrationLead = ({ trackOnMount = false } = {}) => {
  const { events } = useFlixApiContext()

  const trackRegistrationLead = () => {
    if (!leadTrackedStore.get()) {
      leadTrackedStore.set(true)
      events.emit(flixApiEvents.LEAD)
    }
  }

  useEffect(() => {
    if (trackOnMount) {
      trackRegistrationLead()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return { trackRegistrationLead }
}
